/* istanbul ignore file */
import Vue from 'vue'
import store from '@/store'
import { permissions } from '../enums/Permissions'
import { roles } from '../enums/Roles'

/// initial map-generation
generateMaps()

// subscribe to store-mutation
store.subscribe(mutation => {
  if (['SET_PERMISSIONS'].includes(mutation.type)) {
    /// regenerate maps
    generateMaps()
  }
})

function generateMap(args) {
  // create new map from enum-entries with store-values checked
  let map = Object.fromEntries(
    Object.entries(args.enum).map(([key, val]) => [
      args.prefix + key,
      args.storeGetter(val)
    ])
  )

  // extend map with computed invoice-customer
  if (args.enum === roles) {
    map[args.prefix + 'AnyInvoiceCustomer'] =
      map.isInvoiceCustomer || map.isInvoiceCustomerPlus || map.isWebBrief24
  }

  // define property for vue-instanze
  Object.defineProperty(Vue.prototype, args.prototype, {
    value: map,
    enumerable: true,
    configurable: true
  })
}

function generateMaps() {
  generateMap({
    enum: permissions,
    prefix: 'has',
    prototype: '$permissions',
    storeGetter: store.getters.hasPermission
  })
  generateMap({
    enum: roles,
    prefix: 'is',
    prototype: '$roles',
    storeGetter: store.getters.hasRole
  })
}

export default {}
